/* eslint-disable no-unused-vars */
import {API_URL, itemPerPage} from '../constants/index.js';
import {
    REPAIR,
    REPAIR_SUCCESS,
    REPAIR_OPEN_SUCCESS,
    REPAIR_CLOSE_SUCCESS,
    REPAIR_ERROR,
    ADD_REPAIR,
    ADD_REPAIR_SUCCESS,
    ADD_REPAIR_ERROR,
    UPDATE_REPAIR,
    UPDATE_REPAIR_SUCCESS,
    UPDATE_REPAIR_ERROR,
    DELETE_REPAIR,
    DELETE_REPAIR_ERROR,
    DELETE_REPAIR_SUCCESS,
    ADD_VIEW_REPAIR,
    ADD_VIEW_REPAIR_SUCCESS,
    ADD_VIEW_REPAIR_ERROR,
    CLOSE_REPAIR,
    CLOSE_REPAIR_ERROR,
    CLOSE_REPAIR_SUCCESS,
    CANCEL_REPAIR,
    CANCEL_REPAIR_ERROR,
    CANCEL_REPAIR_SUCCESS,
    HISTORIC_DASHBOARD_REPAIR_ERROR,
    HISTORIC_DASHBOARD_REPAIR,
    HISTORIC_DASHBOARD_REPAIR_SUCCESS,
    REPAIR_CLOSE_ERROR,
    REPAIR_OPEN_ERROR,
    REPAIRS_FILTERS,
    REPAIRS_FILTERS_SUCCESS,
    REPAIRS_FILTERS_ERROR
} from '../constants/repairConstants';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';


//#region REPAIR (ALL - BYID)
export function getrepair(data) {
    return {
        type: REPAIR,
        data
    }
}

export function getrepairSuccess(data, communityId) {
    return {
        type: REPAIR_SUCCESS,
        data,
        communityId:communityId
    }
}

export function getrepairOpenSuccess(data, communityId) {
    return {
        type: REPAIR_OPEN_SUCCESS,
        data,
        communityId: communityId,
    }
}

export function getrepairCloseSuccess(data, communityId) {
    return {
        type: REPAIR_CLOSE_SUCCESS,
        data,
        communityId: communityId,
    }
}

export function getrepairError(data) {
    return {
        type: REPAIR_ERROR,
        data
    }
}

export function getrepairOpenError(data, communityId) {
    return {
        type: REPAIR_OPEN_ERROR,
        data,
        communityId: communityId,
    }
}

export function getrepairCloseError(data, communityId) {
    return {
        type: REPAIR_CLOSE_ERROR,
        data,
        communityId: communityId,
    }
}

export function getAllRepairs(id) {
    return dispatch => {
        dispatch(getrepair());
        fetch(API_URL+'workOrders/workOrdersByCommunity/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getrepairSuccess(res, id));
                return res;
            })
            .catch(error => {
                dispatch(getrepairError(error));
            })
        
        //Dispatching the dummy data

        // dispatch(getrepairSuccess(dummyRepairs));
    }
};

function getRepairsFilters(data) {
    return {
        type: REPAIRS_FILTERS,
        data
    }
}

function getRepairsFiltersSuccess(data, tab, communityId, page) {
    return {
        type: REPAIRS_FILTERS_SUCCESS,
        data: data,
        tab: tab,
        communityId: communityId,
        page:page
    }
}

function getRepairsFiltersError(data) {
    return {
        type: REPAIRS_FILTERS_ERROR,
        data
    }
}

const getFiltersHeaders = (filters, idCommunity, tab,search, sort, direction) => {
    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,
        'tab': tab? tab : 1,
        'custom_sort': sort ? sort : 'createdDate',
        'sort_dir': direction === true ? 1 : -1

    }

    if (filters.dateOptionSelected) {
        headers.date_option = filters.dateOptionSelected

    } else if (filters.dateChanged && !filters.dateOptionSelected) {
        headers.start_date = filters.startDate
        headers.end_date = filters.endDate
    }

    if (filters.itemsSelected && filters.itemsSelected.length > 0) {
        headers.items = filters.itemsSelected.join(',');

        //Just can be issues if there's items selected 
        if (filters.issuesSelected && filters.issuesSelected.length > 0) {
            headers.issues = filters.issuesSelected.join(',')
        }

    }

    if(filters.tab===1){
        if(filters.statusSelected){
            headers.status = filters.statusSelected.join(',');
        }
    }


    if (filters.tab===2 && filters.responseTime) { //If this is true
        headers.response_time = filters.responseTime;

        switch (filters.responseOption) {
            case 'Greater than':
                headers.lower_limit = filters.lowerLimit
                break;

            case 'Less than':
                headers.upper_limit = filters.upperLimit
                break;

            case 'Between':
                headers.lower_limit = filters.lowerLimit
                headers.upper_limit = filters.upperLimit
                break;

            default:
                break;
        }

        headers.response_unit = filters.responseUnit

    }

    //Searching
    if (search && search !== '') {
        headers.search = search;
    }


    return headers;

}

export function GetRepairsFilters(idCommunity, tab, filters, currentPage, search, sort, direction) {
    return async(dispatch) => {
        dispatch(getRepairsFilters());
        
        const headers = getFiltersHeaders(filters, idCommunity, tab ,search, sort, direction);
        
        const res = await fetch(`${API_URL}workorders/filters?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getRepairsFiltersSuccess(res, tab, idCommunity, currentPage));

                return (res && res.length > 0)? {ok:true}: {ok: false};
            })
            .catch(error => {
                dispatch(getRepairsFiltersError(error));

                return {ok:false}
            })

        return res
    }
}

export  function getOpenRepairs(idCommunity, currentPage) {
    return async (dispatch) => {
        dispatch(getrepair());
        const res = await fetch(API_URL+`workOrders/openWorOrderByCommunity?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity
            }
            })
            .then(async(res) => { 

                const data = await res.json();

                if(res.status===200){
                    dispatch(getrepairOpenSuccess(data, idCommunity))

                }else{
                    dispatch(getrepairOpenError([],idCommunity));

                }
                return res
                
            })
            .catch(error => {
                dispatch(getrepairOpenError([],idCommunity));
                return {ok: false}
            });

            return res;
    }
};

export function getCloseRepairs(idCommunity, currentPage) {
    return async (dispatch) => {
        dispatch(getrepair());
        const res = await fetch(API_URL+`workOrders/closeWorOrderByCommunity?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity
            }
            })
            .then(async(res) =>{
                const data = await res.json();

                if(res.status===200){
                    dispatch(getrepairCloseSuccess(data,idCommunity));

                }else{
                    dispatch(getrepairCloseError([],idCommunity));

                }

                return res
            })
            .catch(error => {
                dispatch(getrepairError(error));
                return {ok: false}
            })
        
            return res;
        //Dispatching the dummy data

        // dispatch(getrepairSuccess(dummyRepairs));
    }
};

//#region ADD REPAIR

    export function newRepair(data) {
        return {
            type: ADD_REPAIR,
            data
        }
    }

    export function newRepairSuccess(data) {
        return {
            type: ADD_REPAIR_SUCCESS,
            data
        }
    }

    export function newRepairError(data) {
        return {
            type: ADD_REPAIR_ERROR,
            data
        }
    }

    export function addRepair(data) {
        return dispatch => {

            // dispatch(newRepairSuccess(data));
           
            
            dispatch(newRepair());
            fetch(API_URL+'/workorders/workorders',
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'userid':'5ebc576ca0340e062cb61203',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Content-Type':'application/json' ,
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => res.json())
                .then(res => {
                    
                    data._id = res._id;
                    dispatch(newRepairSuccess(data));
                    return res;
                })
                .then( () =>{
                    //const message = `The element ${data.name} has been added succesesfully`
                    const message = `The element ${data.issue.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddRepair_Success');
                })
                .catch(error => {
                    dispatch(newRepairError(error));

                    //const message = `An ERROR occurred trying to add the repair ${data.name} `
                    const message = `An error occurred when trying to add the issue ${data.issue.name} `

                    sweetAlert('error',message,'alert_AddRepair_Error');
                })
        }
    }

//#endregion

//#region UPDATE REPAIR

    export function modRepair(data) {
        return {
            type: UPDATE_REPAIR,
            data
        }
    }

    export function modRepairSuccess(data) {
        return {
            type: UPDATE_REPAIR_SUCCESS,
            data
        }
    }

    export function modRepairError(data) {
        return {
            type: UPDATE_REPAIR_ERROR,
            data
        }
    }

    export function updRepair( data) {
        return dispatch => {
            
            
            // dispatch(modRepairSuccess(data));

            fetch(API_URL+'/workorders/workorders/'+ data._id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(modRepairSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.issue.name} has been updated successfully`

                    sweetAlert('success',message,'alert_UpdateRepair_Success');
                })
                .catch(error => {
                    dispatch(modRepairError(error));

                    const message = `An error occurred when trying to update the issue ${data.issue.name} `

                    sweetAlert('error',message,'alert_UpdateRepair_Error');
                })
        }
    }

//#endregion

//#region DELETE REPAIR

export function deleteRepair(data) {
    return {
        type: DELETE_REPAIR,
        data
    }
};

export function deleteRepairSuccess(data) {
  
    return {
        type: DELETE_REPAIR_SUCCESS,
        data
    }
};

export function deleteRepairError(data) {
    return {
        type: DELETE_REPAIR_ERROR,
        data
    }
};

export function delRepair(id, data) {
    return dispatch => {
        
        dispatch(deleteRepairSuccess(id));
        sweetAlert('success','element deleted successfully','alert_DeleteRepair_Success');

        // dispatch(deleteRepair());
        
        // fetch(API_URL+'rooms/rooms/'+ id,
        //     {
        //         method: 'DELETE',
        //         headers: { 
        //             'Content-Type':'application/json' ,
        //             'Authorization': 'Bearer '+localStorage.getItem('token')
        //     }
        //     })
        //     .then(res => {
        //         dispatch(deleteRepairSuccess(id));
        //         return res;
        //     })
        //     .then( () =>{
        //         const message = `The element has been deleted succesesfully`

        //         GeneralAlert('success',message);
        //     })
        //     .catch(error => {
        //         dispatch(deleteRepairError(error));

        //         const message = `An ERROR occurred trying to update the room `

        //         GeneralAlert('error',message);
        //     })
    }
};



export function closeRepair(item){
    return dispatch => {
           fetch(API_URL+'workorders/closeWorkOrder/'+ item._id,
            {
                method: 'PUT',
                 headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(modRepairSuccess(item));
                return res;
            })
            .then( () =>{
                const message = `Work order has been closed successfully`

                sweetAlert('success',message,'alert_CloseRepair_Success');
            })
            .catch(error => {
                dispatch(modRepairError(error));

                const message = `An error occurred when trying to closed the repair `

                sweetAlert('error',message,'alert_CloseRepair_Error');
            })
    }

}
//#endregion

//#region Schedule WORKORDER

export function scheduleWorkOrder(data) {
    return {
        type: UPDATE_REPAIR,
        data
    }
}

export function scheduleWorkOrderSuccess(data) {
    return {
        type: UPDATE_REPAIR_SUCCESS,
        data
    }
}

export function scheduleWorkOrderError(data) {
    return {
        type: UPDATE_REPAIR_ERROR,
        data
    }
}

export function ScheduleWorkOrder(id, data,scheduleData, showAlerts= true, objStyles) {
    return dispatch => {

        dispatch(scheduleWorkOrder());
        fetch(API_URL+'workorders/workOrderScheduled/'+ id,
            {
                method: 'PUT',
                body: JSON.stringify(scheduleData),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(scheduleWorkOrderSuccess(res));
                return res;
            })
            .then( () =>{
                const itemIssue = (data && data.item && data.item.name && data.issue && data.issue.name)? `${data.item.name.toLowerCase()} ${data.issue.name.toLowerCase()}` : '';
                const message = `The repair(s) has been scheduled successfully`

                if(showAlerts){

                    sweetAlert('success',message,'alert_ScheduleRepair_Success', objStyles);
                }

            })
            .catch(error => {
                dispatch(scheduleWorkOrderError(error));

                const message = `An error occurred when trying to schedule the repair(s) ${data.name} `

                if(showAlerts){
                    sweetAlert('error',message,'alert_ScheduleRepair_Error', objStyles);
                }
            })
    }
}

//#endregion

//#region ADD  Work Order View
export function addViewWorkOrder(data) {
    return {
        type: ADD_VIEW_REPAIR,
        data
    }
}

export function addViewWorkOrderSuccess(data) {
    return {
        type: ADD_VIEW_REPAIR_SUCCESS,
        data
    }
}

export function addViewWorkOrderError(data) {
    return {
        type: ADD_VIEW_REPAIR_ERROR,
        data
    }
}

export function AddViewWorkOrder(repairId, viewByObj) {
    return async (dispatch) => {

        dispatch(scheduleWorkOrder());
        const res = await fetch(API_URL+'workorders/workOrderView/'+ repairId,
            {
                method: 'PUT',
                body: JSON.stringify(viewByObj),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(scheduleWorkOrderSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(scheduleWorkOrderError(error));
                return {ok:false}

            })
        return res
    }
}

//#endregion

//#region  CLOSE REPAIRS



export function closeRepairs(data) {
    return {
        type: CLOSE_REPAIR,
        data
    }
};

export function closeRepairsSuccess(data) {
  
    return {
        type: CLOSE_REPAIR_SUCCESS,
        data
    }
};

export function closeRepairsError(data) {
    return {
        type: CLOSE_REPAIR_ERROR,
        data
    }
};



export function CloseRepairs(repairsToClose, objStyles){
    return dispatch => {
           dispatch(closeRepairs(repairsToClose));

           fetch(API_URL+'/workorders/closeWorkOrders',
            {
                method: 'PUT',
                body: JSON.stringify(repairsToClose),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(closeRepairsSuccess(repairsToClose));
                return res;
            })
            .then( () =>{
                const message = `The repair(s) has been completed successfully`

                sweetAlert('success',message,'alert_CloseRepair_Success', objStyles);
                
            })
            .catch(error => {
                dispatch(closeRepairsError(error));

                const message = `An error occurred when trying to closed the repair(s) `

                sweetAlert('error',message,'alert_CloseRepair_Error', objStyles);
            })
    }

}

//#endregion

//#region  CANCEL REPAIRS

export function cancelRepairs(data) {
    return {
        type: CANCEL_REPAIR,
        data
    }
};

export function cancelRepairsSuccess(data) {
  
    return {
        type: CANCEL_REPAIR_SUCCESS,
        data
    }
};

export function cancelRepairsError(data) {
    return {
        type: CANCEL_REPAIR_ERROR,
        data
    }
};



export function CancelRepairs(repairsToClose, objStyles){

    const profileKeyCloakObj = localStorage.getItem('ky')? JSON.parse(localStorage.getItem('ky')) : undefined;
    let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile)? profileKeyCloakObj.profile:  undefined;
    const givenName = localStorage.getItem('givenName')? localStorage.getItem('givenName') : '';
    const familyName = localStorage.getItem('familyName')? localStorage.getItem('familyName') : '';
    const name = `${givenName} ${familyName}`;
    let canceledBy = (profileObject && profileObject.username)?profileObject.username: name? name : undefined;

    return dispatch => {
           dispatch(cancelRepairs(repairsToClose));

           fetch(API_URL+'/workorders/cancelWorkorders',
            {
                method: 'PUT',
                body: JSON.stringify(repairsToClose),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'userName':canceledBy,
                    'pictureUrl': ''
            }
            })
            .then(res => {
                dispatch(cancelRepairsSuccess(repairsToClose));
                return res;
            })
            .then( () =>{
                const message = `The repair(s) has been canceled successfully`

                sweetAlert('success',message,'alert_CancelRepair_Success', objStyles);
                
            })
            .catch(error => {
                dispatch(cancelRepairsError(error));

                const message = `An error occurred when trying to canceled the repair(s) `

                sweetAlert('error',message,'alert_CancelRepair_Error', objStyles);
            })
    }

}

//#endregion


//#workorders historic dashboard


export function getHistoricDasboardRepair(data){
    return{
        type:HISTORIC_DASHBOARD_REPAIR,
        data
    }
}
export function getHistoricDasboardRepairSuccess(data, communityId){
    return{
        type:HISTORIC_DASHBOARD_REPAIR_SUCCESS,
        data,
        communityId
    }
}
export function getHistoricDasboardRepairError(data){
    return{
        type:HISTORIC_DASHBOARD_REPAIR_ERROR,
        data
    }
}

export function getHistoricDashboard(idCommunity, currentPage) {
    return dispatch => {
        dispatch(getHistoricDasboardRepair());
        fetch(API_URL+`workOrders/historicDashboard`,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'CommunityId':idCommunity,
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getHistoricDasboardRepairSuccess(res, idCommunity));
                return res;
            })
            .catch(error => {
                dispatch(getHistoricDasboardRepairError(error));
            })
        
        //Dispatching the dummy data

        // dispatch(getrepairSuccess(dummyRepairs));
    }
};
